import {EmailDirectionTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class EmailDirectionTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in EmailDirectionTypeCd ) {
      this._values.push(EmailDirectionTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): EmailDirectionTypeCd {

    for ( const obj in EmailDirectionTypeCd ) {
      if (EmailDirectionTypeCd[obj] === value){
        return EmailDirectionTypeCd[obj] as EmailDirectionTypeCd;
      }
    }
  }
}

const EmailDirectionTypeCdHelper = new EmailDirectionTypeCdHelperEnumHelperClass();
export default EmailDirectionTypeCdHelper;
